var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47344 14.5836C5.12656 14.5836 2.39062 11.8477 2.39062 8.50078C2.39062 5.1539 5.12656 2.41797 8.47344 2.41797C11.8203 2.41797 14.5562 5.1539 14.5562 8.50078C14.5828 11.8477 11.8469 14.5836 8.47344 14.5836ZM8.47344 3.05547C5.47187 3.05547 3.05469 5.49922 3.05469 8.47422C3.05469 11.4492 5.49844 13.893 8.47344 13.893C11.4484 13.893 13.8922 11.4492 13.8922 8.47422C13.8922 5.49922 11.475 3.05547 8.47344 3.05547Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3857 11.6094L8.12793 9.35156V5.23438H8.84511V9.05937L10.8904 11.1047L10.3857 11.6094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.b7f60b7033a336900f83efafb4e1b8d1.svg";
export { ForwardRef as ReactComponent };